import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import type { IResponseInboxDeleted } from 'entities/Inbox/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventInboxDeleted = () => {
  const { inboxesStore, websocket, usersStore } = useEntitiesContext()

  const handle = (data: IResponseInboxDeleted) => {
    inboxesStore.deleteItem(data.id)

    if (inboxesStore.currentInboxId === data.id) {
      usersStore.fetchUsersMe()
    }
  }

  useEffect(() => websocket.on(WebsocketEvent.InboxDeleted, handle), [])
}
